<script>
    import R, {LOADER} from "../lib/requests";
    import {setFocusTo} from "../lib/lib";
    import Modal from '../components/modal/Modal.svelte';
    import Checkbox from "../components/controls/Checkbox.svelte";
    import Notifier from "../stores/notifier";

    export let userId = null;
    export let closeCallback;

    let user = null;
    let changePassword = false;
    let roles = [
        {role: 0, name: 'Χρήστης'},
        {role: 1, name: 'Διαχειριστής'},
    ];

    const initialize = () => {
        if (userId == 0) {
            user = {
                id: 0,
                is_admin: 0,
                name: '',
                username: '',
                password: '',
                role_id: 0,
            }
            setFocusTo('userName');
        } else {
            load();
        }
    }

    const load = () => {

        const onSuccess = result => {
            user = result;
            user.is_admin = ~~user.is_admin;
            user.role_id = ~~user.role_id;
            setFocusTo('userName');
        };

        const onFailure = err => {
        };

        R.handle(R.user.details, userId, onSuccess, onFailure, LOADER.POPUP);
    };


    const save = () => {
        const onSuccess = result => {
            Notifier.showMessage("Ο λογαριασμός του χρήστη ενημερώθηκε");
            close(result);
        }

        const onFailure = err => {
            if (err.message) {
                Notifier.showError(err.message);
                if (err.code == 'user_account_exist') {
                    setFocusTo("userEmail");
                }
            }
        };


        user.name = user.name.trim();
        user.username = user.username.trim();
        if (!user.name) {
            Notifier.showError("Πληκτρολογήστε το όνομα του χρήστη");
            setFocusTo("userName");
            return;
        }
        if (!user.username) {
            Notifier.showError("Πληκτρολογήστε το email τους λογαριασμού");
            setFocusTo("userEmail");
            return;
        }
        if (user.id == 0 && !user.password) {
            Notifier.showError("Πληκτρολογήστε έναν κωδικό για τον λογαριασμό");
            setFocusTo("password");
            return;
        }
        if (changePassword && !user.password) {
            Notifier.showError("Πληκτρολογήστε τον νέο κωδικό του λογαριασμού");
            setFocusTo("newPassword");
            return;
        }

        if (user.id > 0 && !changePassword) {
            delete (user.password);
        }

        let action = userId == 0 ? 'create' : 'edit';
        R.handle(R.user[action], user, onSuccess, onFailure, LOADER.POPUP);
    }

    const close = (param) => {
        user = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    const toggleChangePassword = () => {
        changePassword = !changePassword;
        if (changePassword) {
            setFocusTo("newPassword");
        } else {
            delete (user.password);
        }
    }

    initialize();
</script>

{#if user}
    <Modal title="Λογαριασμός Χρήστη" on:close="{ close }">
        <div slot="body">
            <div class="form-group">
                <label>Όνομα</label>
                <input type="text" class="form-control" id="userName" bind:value="{ user.name }">
            </div>
            <div class="form-group">
                <label>Όνομα χρήστη</label>
                <input type="text" class="form-control" id="userEmail" bind:value="{ user.username }">
            </div>
            {#if user.id == 0}
                <div class="form-group">
                    <label>Κωδικός</label>
                    <input type="text" class="form-control" id="password" bind:value="{ user.password }">
                </div>
            {:else}
                {#if !changePassword}
                    <div class="form-group">
                        <button class="btn btn-link ps-0" on:click="{ toggleChangePassword }">
                            Αλλαγή κωδικού
                        </button>
                    </div>
                {:else}
                    <div class="form-group">
                        <label>Νέος κωδικός</label>
                        <input type="text" class="form-control" id="newPassword" bind:value="{ user.password }">
                        <button class="btn btn-link ps-0" on:click="{ toggleChangePassword }">
                            Να μην αλλάξει ο κωδικός
                        </button>
                    </div>
                {/if}
            {/if}
            <div class="form-group">
                <label>Είδος χρήστη</label>
                <select class="form-select" bind:value="{ user.role_id }" disabled="{ user.id == 1 }">
                    {#each roles as item}
                        <option value="{ item.role }">{ item.name }</option>
                    {/each}
                </select>
            </div>
            <hr>
            <div class="text-end">
                <div class="btn btn-link me-4" on:click="{ () => close() }">Κλείσιμο</div>
                <button class="btn btn-primary px-4" on:click="{ save }">Ενημέρωση</button>
            </div>
        </div>
    </Modal>
{/if}